import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ListProductEntityParams {
  listId: number | string;
  product: number | string;
  inventoryId: number | string;
  distributor?: number | string;
  productLine: number | string;
  service: string;
}
export class ListProductEntity extends BaseEntityClass {
  listId: number | string;
  product: number | string;
  inventoryId: number | string;
  distributor?: number | string;
  productLine: number | string;
  service: string;
  constructor(params: ListProductEntityParams) {
    super();
    this.type = "list_product";
    this.entity_version = 2;
    this.listId = params.listId;
    this.product = params.product;
    this.inventoryId = params.inventoryId;
    this.distributor = params.distributor;
    this.productLine = params.productLine;
    this.service = params.service;
  }
}
